import { render, staticRenderFns } from "./TaskComment.vue?vue&type=template&id=7a4ff43c&scoped=true&"
import script from "./TaskComment.vue?vue&type=script&lang=js&"
export * from "./TaskComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ff43c",
  null
  
)

export default component.exports